import { Dialog } from "primereact/dialog";
import { useEffect, useRef, useState } from "react";
import Langs, { Localize } from "../../app/lang/langs";
import { InputText } from "primereact/inputtext";
import { Col } from "react-bootstrap";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { useDispatch, useSelector } from "react-redux";
import { showErrorToast, showSuccessToast } from "../../app/utils/helpers";
import { editTeam, getTeams, changeTeamActiveStatus } from "../../components/teams/teamsSlice";
import { InputNumber } from "primereact/inputnumber";
import { updateTeamSettings } from "../settings/settingsSlice";
import { DynamicButton } from "../../components/buttons/DynamicButton";
import { AssetsPannel } from "../../components/inputs/AssetsPannel";
import { contractsLocationsOptions } from "../../components/collabs/collabsSlice";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';


export default function TeamsDetailsModal(props) {

    let visible = props.visible
    let team = props.team

    const dispatch = useDispatch()

    const settings = useSelector((state) => state.settings)

    const [teamData, setTeamData] = useState(
        {
            id: null,
            value: null,
            label: null,
            frais_transport: null,
            forfait_deplacement: null,
            lunchBreakDuration: null,
            client: null,
            localization: null,
            vfact: null,
            sous_service: null,
            settings: [
                {
                    id: null,
                    label: null,
                    value: null,
                    type: null,
                    min: null,
                    max: null
                },
                {
                    id: null,
                    label: null,
                    value: null,
                    type: null,
                    min: null,
                    max: null
                },
                {
                    id: null,
                    label: null,
                    value: null,
                    type: null,
                    min: null,
                    max: null
                }
                , {
                    id: null,
                    label: null,
                    value: null,
                    type: null,
                    min: null,
                    max: null
                },
                {
                    id: null,
                    label: null,
                    value: null,
                    type: null,
                    min: null,
                    max: null
                }
            ],
            assets: [],
        }
    )

    const [localization, setLocalization] = useState(null)
    const [country, setCountry] = useState(null)
    const [type, setType] = useState(null)

    useEffect(() => {
        setLocalization({ name: teamData.localization })
    }, [teamData.localization])

    useEffect(() => {
        setCountry(teamData.id_country)
    }, [teamData.id_country])

    useEffect(() => {
        setType({ name: teamData.type })
    }, [teamData.type])

    const handleLocalizationChange = (e) => {
        const newLocation = e.value
        setLocalization(newLocation)
        setTeamData(prevData => ({
            ...prevData,
            localization: newLocation?.name
        }))
    }

    const handleCountryChange = (e) => {
        const newCountry = e.value
        setCountry(newCountry)
        setTeamData(prevData => ({
            ...prevData,
            id_country: newCountry
        }))
    }

    const handleTypeChange = (e) => {
        const newType = e.value;
        setType(newType);
        setTeamData(prevData => ({
            ...prevData,
            type: newType?.name
        }));
    }

    useEffect(() => {
        if (team) {
            setTeamData(team);
        } else {
            setTeamData({
                id: null,
                value: null,
                label: null,
                frais_transport: null,
                forfait_deplacement: null,
                lunchBreakDuration: null,
                client: null,
                localization: null,
                vfact: null,
                sous_service: null,
                settings: [
                    {
                        id: null,
                        label: null,
                        value: null,
                        type: null,
                        min: null,
                        max: null
                    },
                    {
                        id: null,
                        label: null,
                        value: null,
                        type: null,
                        min: null,
                        max: null
                    },
                    {
                        id: null,
                        label: null,
                        value: null,
                        type: null,
                        min: null,
                        max: null
                    }
                    , {
                        id: null,
                        label: null,
                        value: null,
                        type: null,
                        min: null,
                        max: null
                    },
                    {
                        id: null,
                        label: null,
                        value: null,
                        type: null,
                        min: null,
                        max: null
                    }
                ],
                assets: [],
            }
            );
        }
    }, [team]);
    const onHide = () => {
        props.setVisible(false);
        props.setTeam(null);
        setTeamData({
            id: null,
            value: null,
            label: null,
            frais_transport: null,
            forfait_deplacement: null,
            lunchBreakDuration: null,
            client: null,
            localization: null,
            vfact: null,
            sous_service: null,
            settings: [
                {
                    id: null,
                    label: null,
                    value: null,
                    type: null,
                    min: null,
                    max: null
                },
                {
                    id: null,
                    label: null,
                    value: null,
                    type: null,
                    min: null,
                    max: null
                },
                {
                    id: null,
                    label: null,
                    value: null,
                    type: null,
                    min: null,
                    max: null
                }
                , {
                    id: null,
                    label: null,
                    value: null,
                    type: null,
                    min: null,
                    max: null
                },
                {
                    id: null,
                    label: null,
                    value: null,
                    type: null,
                    min: null,
                    max: null
                }
            ],
            assets: [],
        });
    };

    const header = () => {
        let name = team?.label;
        return (
            <div className="d-flex justify-content-between border-bottom pb-4">
                <h5 className="m-0">{name}</h5>
            </div>
        );
    };

    const closeIcon = () => {
        return (
            <button className="btn btn-sm btn-danger" onClick={onHide}>X</button>
        );
    }

    const updateTeam = () => {
        if (teamData && teamData.id && teamData.label.trim() !== '') {
            dispatch(editTeam({
                idTeam: teamData.id,
                //client_name: teamData.client,
                name: teamData.label,
                sous_service: teamData.sous_service,
                localization: teamData.localization,
                lunch_break_duration: teamData.lunchBreakDuration,
                frais_transport: teamData.frais_transport,
                forfait_deplacement: teamData.forfait_deplacement,
                vfact: teamData.vfact,
                id_country: teamData.id_country
            }))
                .then((response) => {
                    const responseData = response.payload.responseData;
                    if (responseData && responseData.status === 1) {
                        showSuccessToast("Équipe modifié avec succès");
                    }
                })
                .catch((error) => {
                    showErrorToast("An error occurred while updating team details.");
                    console.error("An error occurred while updating team:", error);
                    return
                });

            let fields = teamData.settings.map(setting => {
                return {
                    id: setting.id,
                    value: parseFloat(setting.value)
                }
            });
            dispatch(updateTeamSettings({
                fields: fields,
                idTeam: teamData.id
            }))
                .then((response) => {
                    const responseData = response.payload.responseData;
                    if (responseData && responseData.status === 1) {
                        showSuccessToast("Équipe paramètres modifié avec succès");
                        dispatch(getTeams());
                        onHide();
                    }
                })
                .catch((error) => {
                    showErrorToast("An error occurred while updating team settings.");
                    console.error("An error occurred while updating team:", error);
                });
        } else {
            showErrorToast('Veuillez remplir le nom du équipe');
        }
    }


    const accept = () => {
        dispatch(changeTeamActiveStatus({
            id_team: teamData.id,
            active: 0
        }))
            .then((response) => {
                const responseData = response.payload.responseData;
                if (responseData && responseData.status === 1) {
                    showSuccessToast(Localize(responseData.message));
                    dispatch(getTeams());
                    onHide();
                } else if (responseData && responseData.status === 0) {
                    showErrorToast(Localize(responseData.message));
                }
            })
            .catch((error) => {
                showErrorToast("An error occurred while deactivating the team.");
                console.error("An error occurred while deactivating team:", error);
            });
    }

    const reject = () => {

    }

    const confirmDelete = () => {
        let message = Localize('DELETE_TEAM_CONFIRM_MESSAGE');
        confirmDialog({
            message: message,
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            draggable: false,
            resizable: false,
            accept,
            reject
        });
    };

    const body = () => {

        return (
            <div className="row " style={{ height: "calc(100vh - 200px)", overflowY: "auto" }}>
                <Col xl={12} className="d-flex justify-content-start pb-4">
                    <h3 className="my-auto"><Langs str='Details' /></h3>
                </Col>
                <Col xl={12} className="d-flex justify-content-between mb-2">
                    <p className="my-auto"><Langs str='Nom' /></p><InputText style={{ width: '25rem' }} placeholder="Nom" value={teamData.label} onChange={(e) => setTeamData({ ...teamData, label: e.target.value })} />
                </Col>
                <Col xl={12} className="d-flex justify-content-between mb-2">
                    <p className="my-auto"><Langs str='FRAIS_TRANSPORT' /></p>
                    <InputNumber inputId="horizontal-buttons" style={{ width: '25rem' }} value={teamData.frais_transport} onValueChange={(e) => setTeamData({ ...teamData, frais_transport: e.value })} showButtons buttonLayout="horizontal" step={0.1}
                        inputClassName={"text-center"} decrementButtonClassName="p-button-warning" incrementButtonClassName="p-button-warning" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus"
                        mode="currency" min={0} currency="EUR" />
                </Col>
                <Col xl={12} className="d-flex justify-content-between mb-2">
                    <p className="my-auto"><Langs str='FORFAIT_DEPLACEMENT' /></p>
                    <InputNumber inputId="horizontal-buttons" style={{ width: '25rem' }} value={teamData.forfait_deplacement} onValueChange={(e) => setTeamData({ ...teamData, forfait_deplacement: e.value })} showButtons buttonLayout="horizontal" step={0.1}
                        inputClassName={"text-center"} decrementButtonClassName="p-button-warning" incrementButtonClassName="p-button-warning" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus"
                        mode="currency" min={0} currency="EUR" />
                </Col>
                <Col xl={12} className="d-flex justify-content-between mb-2">
                    <p className="my-auto"><Langs str='LUNCH_BREAK_DURATION' /></p>
                    <InputNumber inputId="horizontal-buttons" style={{ minWidth: '25rem' }} value={teamData.lunchBreakDuration} onValueChange={(e) => setTeamData({ ...teamData, lunchBreakDuration: e.value })} showButtons buttonLayout="horizontal" step={0.1}
                        inputClassName={"text-center"} min={0} decrementButtonClassName="p-button-warning" incrementButtonClassName="p-button-warning" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus"
                    />
                </Col>
                <Col xl={12} className="d-flex justify-content-between mb-2">
                    <p className="my-auto"><Langs str='CLIENT' /></p><InputText disabled style={{ width: '25rem' }} placeholder="Nom" value={teamData.client} onChange={(e) => setTeamData({ ...teamData, client: e.target.value })} />
                </Col>
                <Col xl={12} className="d-flex justify-content-between mb-2">
                    <p className="my-auto"><Langs str='SOUS_SERVICE' /></p><InputText style={{ width: '25rem' }} placeholder="Nom" value={teamData.sous_service} onChange={(e) => setTeamData({ ...teamData, sous_service: e.target.value })} />
                </Col>
                <Col xl={12} className="d-flex justify-content-between mb-2">
                    <p className="my-auto"><Langs str='vFact' /></p>
                    <InputTextarea
                        rows={4}
                        cols={30}
                        style={{ width: '25rem' }}
                        value={teamData.vfact}
                        onChange={(e) => setTeamData({ ...teamData, vfact: e.target.value })}
                        autoResize={true}
                        placeholder="vFact"
                    />
                </Col>
                <Col xl={12} className="d-flex justify-content-between my-2">
                    <p className="my-auto"><Langs str='country' /></p>
                    <Dropdown value={country}
                        style={{ width: '25rem' }}
                        onChange={handleCountryChange}
                        options={settings.countries}
                        optionLabel="label"
                        placeholder="Country..."
                        className="w-full md:w-14rem" />
                </Col>
                <Col xl={12} className="d-flex justify-content-between my-2">
                    <p className="my-auto"><Langs str='localization' /></p>
                    <Dropdown value={localization}
                        style={{ width: '25rem' }}
                        onChange={handleLocalizationChange}
                        options={contractsLocationsOptions}
                        optionLabel="name"
                        placeholder="Localization..."
                        className="w-full md:w-14rem" />
                </Col>
                <Col xl={12} className="d-flex justify-content-start pt-3 pb-4 mt-3 border-top">
                    <h3 className="my-auto"><Langs str='Settings' /></h3>
                </Col>
                <Col xl={12} className="d-flex flex-column justify-content-between mb-2">
                    {teamData.settings.map((setting, index) => (
                        setting.type === 'number' && (
                            <div key={setting.id || index} className="d-flex justify-content-between align-items-center mb-2">
                                <p className="my-auto"><Langs str={setting.label} /></p>
                                <InputNumber
                                    inputId={`setting-${index}`}
                                    style={{ width: '25rem' }}
                                    value={setting.value}
                                    onValueChange={(e) => {
                                        console.log(e)
                                        const newSettings = [...teamData.settings];
                                        newSettings[index] = { ...newSettings[index], value: e.value };
                                        setTeamData({ ...teamData, settings: newSettings });
                                    }}
                                    showButtons
                                    buttonLayout="horizontal"
                                    min={setting.min}
                                    max={setting.max}
                                    maxFractionDigits={5}
                                    step={1}
                                    inputClassName={"text-center"}
                                    decrementButtonClassName="p-button-warning"
                                    incrementButtonClassName="p-button-warning"
                                    incrementButtonIcon="pi pi-plus"
                                    decrementButtonIcon="pi pi-minus"
                                />
                            </div>
                        )
                    ))}
                </Col>
                <AssetsPannel
                    tableName='teams'
                    idParent={teamData?.id}
                    assets={teamData?.assets}
                    uploadCallBackFunction={() => { }}
                    deleteCallBackFunction={() => { }}
                    label="Assets"
                    parentSetter={setTeamData}
                />
            </div>
        )
    }

    const footer = () => {
        return (
            <div className="d-flex justify-content-between border-top pt-4 row">
                <Col xl={3}>

                    <DynamicButton
                        onClick={() => { confirmDelete('bottom-right') }}
                        title={<Langs str="DEACTIVATE_TEAM" />}
                        active={true}
                        color="red"
                    />
                </Col>
                <Col xl={3}>
                    <DynamicButton
                        color='green'
                        onClick={() => { updateTeam() }}
                        title="SAVE"
                        active={true}
                    />
                </Col>
            </div>
        )
    }


    return (
        <div>
            <Dialog
                header={header}
                visible={visible}
                draggable={false}
                position="right"
                style={{ width: '55rem', height: "100vh", maxHeight: "100%", marginRight: 0 }}
                onHide={onHide}
                //closeIcon={closeIcon}
                footer={footer}
            >
                {body()}
            </Dialog>
        </div>
    );
}